import { FormattedMessage } from 'react-intl';
import { Image } from '@/components/Image';

export const Header = () => {
  return (
    <div className="sticky top-0 z-10 bg-white w-full">
      <div className="p-5 w-full">
        <span className="text-[30px] leading-9 font-extrabold h-9 inline-block">
          <FormattedMessage id="order_title" defaultMessage="Order review" />
        </span>
      </div>
      <div className="flex items-center h-14 py-4 px-5 bg-[#f5f5f5] text-[16px] font-medium leading-6 text-[#808080]">
        <Image src="/icons/notice.svg" alt="notice-icon" className="mr-2" width={16} />
        <FormattedMessage id="order_notification" defaultMessage="This form can only be entered in English." />
      </div>
    </div>
  );
};
